module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-gallery"
  }, [_c('ul', {
    staticClass: "gallery"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.openLightbox(index)
        }
      }
    }, [_c('sky-crop', {
      attrs: {
        "mode": "cover",
        "src": item.src
      }
    }), _vm._v(" "), _c('button', [_c('sky-svg', {
      attrs: {
        "name": "open-external"
      }
    })], 1)], 1)
  })), _vm._v(" "), (_vm.lightbox) ? [_c('sky-lightbox', {
    attrs: {
      "type": "images",
      "name": _vm.lightbox,
      "items": _vm.items
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-0b664fd6"}!./scripts/sky-gallery/sky-gallery.html
// module id = 362
// module chunks = 1